export function formatAPIError(error: Error): string {
  return error?.message?.replace(/bad request: /i, '') || '';
}
